import * as React from 'react';

import type { W_Material_FindGroups_VM_Single } from 'ab-api/web/material/findGroups';

import { DEBOUNCE_TIME } from '@acceligentllc/shared/constants/value';

import { debounce } from 'af-utils/actions.util';

import Dropdown from 'af-components/Controls/Dropdown';
import SearchInput, { useSearchInputState } from 'af-components/Controls/SearchInput';

import styles from './styles.module.scss';

export interface TableFilterSelection {
	group: Nullable<string>;
	search: string;
}

interface GroupItem {
	name: string;
}

interface OwnProps {
	className: string;
	disabled: boolean;
	filters: TableFilterSelection;
	groups: GroupItem[];
	onChange: (filters: TableFilterSelection) => void;
	onLoadRequest: () => void;
}

type Props = OwnProps;

const TableFilters: React.FC<Props> = (props) => {
	const { className, disabled, filters, groups, onLoadRequest, onChange } = props;

	const searchInput = useSearchInputState();

	const handleGroupChange = React.useCallback((group: Nullable<GroupItem>) => {
		onChange({ ...filters, group: group?.name ?? '', search: '' });
		searchInput.onChange('');
	}, [filters, onChange, searchInput]);

	const onChangeDebounced = React.useMemo(() => debounce(onChange, DEBOUNCE_TIME), [onChange]);

	React.useEffect(() => {
		if (searchInput.value !== filters.search) {
			onChangeDebounced({ ...filters, search: searchInput.value });
		}
	}, [filters, onChangeDebounced, searchInput.value]);

	const resolvedClassName = `${styles.TableFilters} ${className}`;

	return (
		<div className={resolvedClassName}>
			<div className={styles.search}>
				<SearchInput
					placeholder="Search"
					{...searchInput}
				/>
			</div>
			<Dropdown<W_Material_FindGroups_VM_Single>
				blankOption="All"
				disabled={disabled}
				hasBlankOption={true}
				labelKey="name"
				onFocus={onLoadRequest}
				onValueChange={handleGroupChange}
				options={groups}
				placeholder="Select Group"
				valueKey="name"
				withBorder={true}
				withCaret={true}
			/>
		</div>
	);
};

export default React.memo(TableFilters);
